module.exports = __webpack_public_path__ + "static/img/ic-4.507cc90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/ic-4.svg
// module id = dZFu
// module chunks = 1